<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="bookList1" :search="search"
                class="elevation-1 mytable" dense>
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Assessment Scheme Group</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"></span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"></v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-dialog v-model="dialog" max-width="600px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Assessment Scheme Group</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model.number="editedItem.groupno" type="number"
                                                        :rules="[
                            (v) => !!v || v === 0 || 'Group Number is required',
                            (v) => v >= 0 || 'Group Number must be non-negative'
                          ]" label="Group Number" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model="editedItem.groupname" :rules="[
                            (v) => !v || v.length <= 50 || 'Group Name must be less than 50 characters'
                          ]" label="Group Name" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model.number="editedItem.number_of_best"
                                                        type="number" :rules="[
                            (v) => v >= 0 || 'Number of Best must be non-negative'
                          ]" label="Number of Best" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model="editedItem.evaluation_rule" :rules="[
                            (v) => !v || v.length <= 100 || 'Evaluation Rule must be less than 100 characters'
                          ]" label="Evaluation Rule" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model.number="editedItem.converted_marks"
                                                        type="number" :rules="[
                            (v) => v >= 0 || 'Converted Marks must be non-negative'
                          ]" label="Converted Marks" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model.number="editedItem.evaluated_marks"
                                                        type="number" :rules="[
                            (v) => v >= 0 || 'Evaluated Marks must be non-negative'
                          ]" label="Evaluated Marks" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model.number="editedItem.passing_marks"
                                                        type="number" :rules="[
                            (v) => v >= 0 || 'Passing Marks must be non-negative'
                          ]" label="Passing Marks" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field v-model="editedItem.display_passing_marks" :rules="[
                            (v) => !v || v.length <= 50 || 'Display Passing Marks must be less than 50 characters'
                          ]" label="Display Passing Marks" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-autocomplete v-model="editedItem.assessmentscheme_id"
                                                        :items="assessment_scheme_list" item-text="name" item-value="id"
                                                        label="Assessment Scheme" persistent-hint
                                                        :rules="[(v) => !!v || 'Assessment Scheme is required']"
                                                        clearable></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-select v-model="editedItem.assessmenttypegradegroup_id"
                                                        :items="assessment_type_grade_group_list" item-text="name"
                                                        item-value="id" label="Assessment Type Grade Group"
                                                        persistent-hint></v-select>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-select v-model="editedItem.assessment_type" multiple
                                                        :items="assessment_type_list" item-text="name"
                                                        item-value="id" label="Assessment Type"
                                                        persistent-hint></v-select>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                    
                    <v-row class="px-4 pb-2" justify="start" align="center">
            <template v-for="header in headers">
                <v-col v-if="filters.hasOwnProperty(header.value)" :key="header.value" cols="12" sm="4" md="3">
                    <v-autocomplete 
                        class="mr-2 pb-2 pt-2" 
                        flat 
                        hide-details 
                        small 
                        rounded 
                        dense 
                        outlined
                        color="#0F2027" 
                        :label="header.text" 
                        multiple 
                        clearable
                        :items="columnValueList(header.value)" 
                        v-model="filters[header.value]"
                    ></v-autocomplete>
                </v-col>
            </template>
        </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">edit</v-icon>
                        <v-icon class="mr-2" size="25" @click="deleteItem(item)" color="error">mdi-delete</v-icon>
                    </div>
                </template>
            </v-data-table>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline toolbar">Confirm Delete</v-card-title>
                    <v-card-text class="pt-4" style="color: black; font-size: 15px;">
                        Are you sure you want to delete Assessment Scheme Group 
                        <strong >'{{ itemToDelete ? itemToDelete.groupno : '' }}'</strong>?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="error" text @click="confirmDelete">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        data: () => ({
            valid: false,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            dialogDelete: false,
            itemToDelete: null,
            assessment_scheme_list: [],
            assessment_type_grade_group_list: [],
            assessment_type_list:[],
            headers: [
                { text: "Group Number", align: "left", sortable: true, value: "groupno" },
                { text: "Group Name", align: "left", sortable: false, value: "groupname" },
                { text: "Number of Best", align: "left", sortable: true, value: "number_of_best" },
                { text: "Evaluation Rule", align: "left", sortable: false, value: "evaluation_rule" },
                { text: "Converted Marks", align: "left", sortable: true, value: "converted_marks" },
                { text: "Evaluated Marks", align: "left", sortable: true, value: "evaluated_marks" },
                { text: "Passing Marks", align: "left", sortable: true, value: "passing_marks" },
                { text: "Display Passing Marks", align: "left", sortable: false, value: "display_passing_marks" },
                { text: "Assessment Scheme", align: "left", sortable: false, value: "assessmentscheme" },
                { text: "Assessment Type Grade Group", align: "left", sortable: false, value: "assessmenttypegradegroup" },
                { text: "Assessment Type", align: "left", sortable: false, value: "assessmenttype_names" },
                { text: "Actions", value: "action", sortable: false },
            ],
            filters: {
            groupname: [],
            assessmentscheme: [],
            assessmenttypegradegroup: [],
        },
            assessment_scheme_group_list: [],
            assessment_type_grade_group_list: [],
            assessment_scheme_list: [],
            editedIndex: -1,
            editedItem: {
                id: null,
                groupno: 0,
                groupname: "",
                number_of_best: 0,
                evaluation_rule: "",
                converted_marks: 0,
                evaluated_marks: 0,
                passing_marks: 0,
                display_passing_marks: "",
                assessmentscheme_id: null,
                assessmenttypegradegroup_id: null,
                assessmentscheme: "",
                assessmenttypegradegroup: "",
                assessment_type: [],
            },
            defaultItem: {
                id: null,
                groupno: 0,
                groupname: "",
                number_of_best: 0,
                evaluation_rule: "",
                converted_marks: 0,
                evaluated_marks: 0,
                passing_marks: 0,
                display_passing_marks: "",
                assessmentscheme_id: null,
                assessmenttypegradegroup_id: null,
                assessmentscheme: "",
                assessmenttypegradegroup: "",
                assessment_type: [],
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Assessment Scheme Group" : "Edit Assessment Scheme Group";
            },
            bookList1() {
                if (!this.assessment_scheme_group_list) return [];

                return this.assessment_scheme_group_list.filter((item) => {
                    return Object.keys(this.filters).every((key) => {
                        const selectedFilters = this.filters[key];

                        // If filter is cleared/empty, let all records pass
                        if (!selectedFilters || selectedFilters.length === 0) return true;

                        // Check if the record value exists in the selected dropdown items
                        const itemValue = item[key] != null ? String(item[key]).trim() : "";
                        return selectedFilters.some(
                            (filterVal) => String(filterVal).trim() === itemValue
                        );
                    });
                });
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            dialogDelete(val) {
        val || this.closeDelete();
    },
        },

        mounted() {
            this.onLoad();
        },

        methods: {
            onLoad() {
                this.overlay = true;
                axios
                    .get("/Examination/getAssessmentSchemeGroup")
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.assessment_scheme_group_list) {
                            this.assessment_scheme_group_list = res.data.assessment_scheme_group_list;
                            this.assessment_scheme_list = res.data.assessment_scheme_list || [];
                            this.assessment_type_grade_group_list = res.data.assessment_type_grade_group_list || [];
                            this.assessment_type_list = res.data.assessment_type_list || [];
                        } else if (res.data.msg && (res.data.msg === "401" || res.data.msg === "403")) {
                            this.showSnackbar("#b71c1c", "Unauthorized access");
                        } else if (res.data.msg === "404") {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                        } else {
                            this.showSnackbar("#b71c1c", "Failed to load Assessment Scheme Groups");
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });
            },

            editItem(item) {
                this.editedIndex = this.assessment_scheme_group_list.indexOf(item);
                this.editedItem = Object.assign({}, item);

                // Safely assign the array of Assessment Type IDs to editedItem.assessment_type
                if (Array.isArray(item.assessment_type)) {
                    this.editedItem.assessment_type = item.assessment_type;
                } else if (item.assessment_type) {
                    this.editedItem.assessment_type = [item.assessment_type];
                } else {
                    this.editedItem.assessment_type = [];
                }

                this.dialog = true;
            },

            deleteItem(item) {
                this.itemToDelete = item;
                this.dialogDelete = true;
            },

            closeDelete() {
                this.dialogDelete = false;
                this.$nextTick(() => {
                    this.itemToDelete = null;
                });
            },

            confirmDelete() {
                if (!this.itemToDelete) return;

                const item = this.itemToDelete;
                this.overlay = true;

                axios
                    .post("/Examination/deleteAssessmentSchemeGroup", { deleteid: item.id, groupno: item.groupno })
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.status && res.data.status.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "Assessment Scheme Group Deleted Successfully");
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to delete Assessment Scheme Group");
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });

                this.closeDelete();
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (!this.valid) return;

                const payload = {
                    groupno: this.editedItem.groupno,
                    groupname: this.editedItem.groupname ? this.editedItem.groupname.trim() : "",
                    number_of_best: this.editedItem.number_of_best,
                    evaluation_rule: this.editedItem.evaluation_rule ? this.editedItem.evaluation_rule.trim() : "",
                    converted_marks: this.editedItem.converted_marks,
                    evaluated_marks: this.editedItem.evaluated_marks,
                    passing_marks: this.editedItem.passing_marks,
                    display_passing_marks: this.editedItem.display_passing_marks ? this.editedItem.display_passing_marks.trim() : "",
                    assessmentscheme_id: this.editedItem.assessmentscheme_id,
                    assessmenttypegradegroup_id: this.editedItem.assessmenttypegradegroup_id,
                    assessmenttype_id: this.editedItem.assessment_type,
                };

                if (this.editedIndex > -1) {
                    // Edit
                    payload.editid = this.editedItem.id;
                    axios
                        .post("/Examination/editAssessmentSchemeGroup", payload)
                        .then((res) => {
                            if (res.data.status && res.data.status.code === "SUCCESS") {
                                Object.assign(this.assessment_scheme_group_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Assessment Scheme Group Updated Successfully");
                                this.onLoad();
                            } else if (res.data.status && res.data.status.code === "NA") {
                                this.showSnackbar("#b71c1c", res.data.status.message);
                            } else if (res.data.msg === "404") {
                                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to update Assessment Scheme Group");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            console.error(error);
                        });
                } else {
                    // Save new
                    axios
                        .post("/Examination/saveAssessmentSchemeGroup", payload)
                        .then((res) => {
                            if (res.data.status && res.data.status.code === "SUCCESS") {
                                this.showSnackbar("#4caf50", "Assessment Scheme Group Added Successfully");
                                this.onLoad();
                            } else if (res.data.status && res.data.status.code === "NA") {
                                this.showSnackbar("#b71c1c", res.data.status.message);
                            } else if (res.data.msg === "404") {
                                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to add Assessment Scheme Group");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            console.error(error);
                        });
                }
                this.close();
            },
            columnValueList(val) {
            return [
                ...new Set(
                    this.assessment_scheme_group_list
                        .map((d) => d[val])
                        .filter((v) => v != null && v !== "")
                ),
            ];
        },
    },
        
    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>